export const MILLISECONDS_SECOND = 1000
export const MILLISECONDS_MINUTE = 60 * MILLISECONDS_SECOND
export const MILLISECONDS_HOUR = 60 * MILLISECONDS_MINUTE
export const MILLISECONDS_DAY = 24 * MILLISECONDS_HOUR
export const DELAY = 1000

export function getTime(date) {
  return +new Date(date) - +Date.now()
}
